import { isValidPassword, getPasswordValidationInfo } from '@upright/common/iam/users/password-validation';
import { BouTextAreaInput } from '@upright/ui/common/generic/components/inputs/bou-text-area-input';
import { BouTextInputFacade } from '@upright/ui/common/generic/components/inputs/bou-text-input-facade';
import { PasswordValidationInfoText } from '@upright/ui/views/login-views/password-validation-info-text';
import { useState } from 'react';
import styled from 'styled-components';
import { SubscriptionTier } from '../../../../../../../common/activities/contact-forms/company-subscription/subscription-tiers';
import { useSubscriptionContext } from '../../context';
import { companyInfoValidators, personalInfoValidators } from '../../validation';
import { InputProps } from './types';

export const FirstNameInput = (props: InputProps) => {
  const [personalInfo, setPersonalInfo] = useSubscriptionContext().personalInfo;
  return (
    <BouTextInputFacade
      value={personalInfo.firstName}
      label={'First name'}
      placeholder={'Type first name'}
      onChange={e => {
        setPersonalInfo({ ...personalInfo, firstName: e.target.value });
      }}
      invalid={!personalInfoValidators.firstName(personalInfo.firstName)}
      invalidText={'Please provide your first name'}
      validateOnBlur={!props.submitButtonClicked}
      id={props.id}
    />
  );
};

export const LastNameInput = (props: InputProps) => {
  const [personalInfo, setPersonalInfo] = useSubscriptionContext().personalInfo;
  return (
    <BouTextInputFacade
      value={personalInfo.lastName}
      label={'Last name'}
      placeholder={'Type last name'}
      onChange={e => {
        setPersonalInfo({ ...personalInfo, lastName: e.target.value });
      }}
      invalid={!personalInfoValidators.lastName(personalInfo.lastName)}
      invalidText={'Please provide your last name'}
      validateOnBlur={!props.submitButtonClicked}
      id={props.id}
    />
  );
};

export const EmailInput = (props: InputProps) => {
  const [personalInfo, setPersonalInfo] = useSubscriptionContext().personalInfo;
  return (
    <BouTextInputFacade
      value={personalInfo.email}
      label={'Email'}
      placeholder={`Type a work email that's related to your company`}
      onChange={e => {
        setPersonalInfo({ ...personalInfo, email: e.target.value });
      }}
      invalid={!personalInfoValidators.email(personalInfo.email)}
      invalidText={'Please provide a valid work email address'}
      validateOnBlur={!props.submitButtonClicked}
      id={props.id}
    />
  );
};

export const CompanyNameInput = (props: InputProps) => {
  const [companyInfo, setCompanyInfo] = useSubscriptionContext().companyInfo;
  return (
    <BouTextInputFacade
      value={companyInfo.name}
      label={'Company name'}
      placeholder={'Type company name'}
      onChange={e => {
        setCompanyInfo({ ...companyInfo, name: e.target.value });
      }}
      invalid={!companyInfoValidators.name(companyInfo.name, SubscriptionTier.STANDARD)}
      invalidText={'Please provide the name of your company'}
      validateOnBlur={!props.submitButtonClicked}
      id={props.id}
    />
  );
};

export const MessageInput = () => {
  const [message, setMessage] = useSubscriptionContext().message;
  return (
    <StyledTextArea
      value={message}
      label={'Message (optional)'}
      placeholder={'Type your message'}
      onChange={e => {
        setMessage(e.target.value);
      }}
    />
  );
};

export const PasswordInput = (props: InputProps) => {
  const [password, setPassword] = useSubscriptionContext().password;
  const [passwordFieldLeft, setPasswordFieldLeft] = useState(false);

  const email = useSubscriptionContext().personalInfo[0].email;

  return (
    <>
      <BouTextInputFacade
        type="password"
        label="Password"
        value={password}
        placeholder="Password"
        onChange={e => {
          const value = e.currentTarget.value;
          setPassword(value);
        }}
        onBlur={() => {
          setPasswordFieldLeft(true);
        }}
        invalid={!isValidPassword(password, email) && passwordFieldLeft}
        validateOnBlur={!props.submitButtonClicked}
        invalidText={''}
        id={props.id}
      />
      {!isValidPassword(password, email) && passwordFieldLeft && (
        <PasswordValidationInfoText
          {...{
            validatedPassword: getPasswordValidationInfo(password, email),
            passwordFieldLeft,
            noUserNameAsked: true,
          }}
        />
      )}
    </>
  );
};

const StyledTextArea = styled(BouTextAreaInput)`
  height: auto;
`;
